function copy_links(){
    let url = document.location.href

    let links = document.querySelectorAll('.copy-link');


    for (let a = 0; a < links.length; a++) {
        const elm = links[a];

        elm.addEventListener('click', function(e){
            e.preventDefault();

            navigator.clipboard.writeText(url).then(function() {
                console.log('Copied!');

                elm.classList.add('copied');
                setTimeout(function(){
                    elm.classList.remove('copied');
                }, 2000);

            }, function() {
                console.log('Copy error')
            });
        });

        
    }

}
   

export default copy_links;
